import { render, staticRenderFns } from "./DeleteCompanyUserDialog.vue?vue&type=template&id=b21efee2&"
import script from "./DeleteCompanyUserDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteCompanyUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports